import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceInterface } from 'src/app/shared/interfaces/service.interface';

@Component({
  selector: 'app-service-collapsible',
  templateUrl: './service-collapsible.component.html',
  styleUrls: ['./service-collapsible.component.scss']
})
export class ServiceCollapsibleComponent {
  @Input() title = ''; 
  @Input() link = ''; 
  @Input() items: ServiceInterface[] = [];

  public isExpanded = false;

   constructor(
      private router: Router
    ) {}

  get hasMoreThanThreeItems(): boolean {
    return this.items.length > 3;
  }

  get visibleItems(): ServiceInterface[] {
    return this.isExpanded ? this.items : this.items.slice(0, 3);
  }

  public toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }

  public handleItemClick(url: string): void {
     this.router.navigate([url]);
  }
}
